export default __webpack_public_path__ + "static/bubble-with-negative-values-6ae0529c63b66689d164386703576ff5.png";